import type { FC } from 'react';

import Info from '@crehana/compass.icons.fill/Info';
import { PlayroomRewardIndicatorWithRive } from '@crehana/compass.playroom';
import { LazyImage } from '@crehana/compass.ui';

import { COURSE_CARD_IMAGE_PARAMS } from '../../constants';
import useTeamCoursesTranslation from '../../hooks/useTeamCoursesTranslation/useTeamCoursesTranslation';
import type { TLayoutLearnTeam } from '../../types';
import LayoutLearnTrack from '../LayoutLearnTrack';

type CardTrackCompletedProps = {
  order: number;
  portraitCertificate: string;
  trackName: string;
  rewardQuantity?: number;
  hasCertificate: boolean;
};

const CardTrackCompleted: FC<CardTrackCompletedProps> = ({
  order,
  portraitCertificate,
  trackName,
  rewardQuantity,
  hasCertificate,
}) => {
  const { t } = useTeamCoursesTranslation();
  const shouldRenderRewardIndicator =
    rewardQuantity !== undefined && rewardQuantity > 0;

  const paramLayout: TLayoutLearnTeam = {
    order: order + 1,
    isMediumT: false,
    isSuccess: true,
    isLast: true,
    porcentage: 0,
  };

  return (
    <LayoutLearnTrack {...paramLayout}>
      <div
        className="sm:dark:tw-bg-transparent dark:tw-bg-elevation-dark-04 tw-bg-neutral-light-100 tw-flex tw-flex-col sm:tw-flex-row tw-p-1.2 tw-relative tw-rounded-0.8 sm:tw-p-0.8"
        role={'listitem'}
      >
        <div className="tw-flex-1 tw-w-full tw-text-left tw-flex tw-flex-col sm:tw-flex-row">
          <div className="tw-relative tw-flex tw-flex-col tw-w-full tw-overflow-hidden tw-rounded-0.8 tw-h-8 tw-mb-0.8 sm:tw-mb-0 sm:tw-mr-1.2 sm:tw-w-[9.2rem] sm:tw-h-[5.2rem] tw-border tw-border-solid tw-border-success-500">
            <LazyImage
              src={portraitCertificate || ''}
              imgxParams={COURSE_CARD_IMAGE_PARAMS}
              alt={trackName || ''}
              isTransparent
              imgClassName="tw-object-cover"
              className="tw-w-full tw-h-full"
            />
          </div>
          <div className="tw-flex tw-flex-col tw-w-full tw-mr-[4.8rem] tw-gap-0.4">
            <span className="tw-font-subtitle5 tw-text-success-500 dark:tw-text-neutral-light-100">
              {t('LEARN_TEAM_TRACK_SUCCESS')}
            </span>
            <div className="tw-flex tw-justify-start tw-items-center tw-flex-row tw-gap-1">
              {shouldRenderRewardIndicator && (
                <div className="tw-flex tw-items-center">
                  <PlayroomRewardIndicatorWithRive
                    coins={rewardQuantity}
                    className="tw-ml-1.2 sm:tw-w-fit tw-h-2.4 sm:tw-ml-0"
                  />
                </div>
              )}
              {!hasCertificate && (
                <div className="tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-flex tw-justify-start tw-gap-0.8 tw-items-center tw-px-0.8 tw-py-[0.6rem] tw-border tw-border-neutral-light-500 tw-border-solid tw-rounded-0.8 tw-bg-neutral-light-200 tw-w-fit">
                  <Info size={16} className="tw-text-current" />
                  <p className="tw-font-body5">
                    Esta ruta <strong>no otorga certificado</strong>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutLearnTrack>
  );
};

export default CardTrackCompleted;
